<template>
<div class="post-area" id="app-modules">
    <div class="wfit post-row-items animate__animated animate__fadeInUp transition-component" v-for="(r,key) in blocks" :key="r.index">
        <module-container :name="r.name" :index="key" :store="store" :displayLanguage="currentLanguge"></module-container>
    </div>
</div>
</template>

<script>
import store from '../store';
import ModuleContainer from './ModuleContainer';

export default {
    data() {
        return {
            store,
        };
    },
    components: {
        ModuleContainer
    },
    computed: {
        blocks() {
            return this.store.state.blocks;
        },
        currentLanguge() {
            return this.store.state.currentLanguge;
        },
    },
    beforeMount() {
        if (this.blocks) {
            this.updateCounter(this.blocks)
            this.store.init('blocks', JSON.parse(JSON.stringify(this.blocks)));
        }
    },
    created() {
        this.store.state.vm = this;
    },
    mounted() {
        this.$quizierEvent.onInit();
    },
    methods: {
        updateCounter(blocks) {
            const locale = this.store.state.currentLanguge;
            let counter = 1;
            blocks.forEach(function (block, index) {
                const block_type = typeof block.contents[locale]['data'].block_type !== 'undefined' ? block.contents[locale]['data'].block_type : false;
                if (block_type == 'list' || block_type == 'rank') {
                    block.contents[locale]['data'].counter = counter
                    counter++;
                }
            });
        }
    }
};
</script>
